import React from 'react';

export default function ResultsSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 })?.map((_, i) => (
        <div
          key={`skeleton-result-${i + 1}`}
          className="bg-card border border-border rounded-2xl p-4"
        >
          <div className="flex flex-wrap items-start gap-4">
            <div className="skeleton-pulse w-10 h-10 rounded-xl flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="skeleton-pulse h-4 w-32 rounded" />
              <div className="skeleton-pulse h-3 w-48 rounded" />
              <div className="skeleton-pulse h-3 w-24 rounded" />
            </div>
            <div className="flex flex-col items-end gap-2">
              <div className="skeleton-pulse h-8 w-20 rounded" />
              <div className="skeleton-pulse h-3 w-16 rounded" />
              <div className="skeleton-pulse h-10 w-28 rounded-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}